// extracted by mini-css-extract-plugin
module.exports = {"paymentDashboardPurchaseNotificator__wrap":"iBwsVa5ubQzNt0p2Wj_FQ","paymentDashboardPurchaseNotificator__text":"_1LhJoMK9vF_yR8l0qY-_Zf"};